"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("circle", { cx: "24", cy: "25", r: "7" }),
  React.createElement("path", { d: "M44 12h-6.75a2 2 0 0 1-1.664-.891l-4.992-4.218A2 2 0 0 0 28.93 6h-9.86a2 2 0 0 0-1.664.891l-4.867 4.219a2 2 0 0 1-1.664.89H4a2 2 0 0 0-2 2v26a2 2 0 0 0 2 2h40a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2zM24 36.3A11.3 11.3 0 1 1 35.3 25 11.3 11.3 0 0 1 24 36.3z" })
);

